import React, { useEffect, useState, useMemo } from 'react';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import { RotatingLines } from 'react-loader-spinner';
import Papa from 'papaparse';
import axios from 'axios';
import { useNavigate, BrowserRouter as Router, Route, Link } from "react-router-dom";
import { FaDownload, FaUpload } from 'react-icons/fa';

function TcclUpload() {
 const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
     const [searchQuery, setSearchQuery] = useState("");
    const [customerData, setCustomerData] = useState([]);
      const navigate = useNavigate();
    const user = getCookie('user');
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
    if (!user) { navigate('/'); }
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLoading(true); // start loading
          Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: async function (results) {
              const stbNumbers = results.data.map(row => row.STBNO); // assuming your header column is STBNO
              console.log("Parsed STBNOs:", stbNumbers);
      
              try {
                const response = await axios.post('https://node.cabletvpay.in/tcclupload', { stbNumbers,user });
                setCustomerData(response.data); // assuming you use useState to store table data
              } catch (error) {
                toast.error("Error fetching customer data.");
              }
              finally { setLoading(false); }
            }
          });
        }
      };
       useEffect(() => {
 
  if (!user) {
    navigate('/');
  } else {
    setLoading(false); // only stop loading after checking cookie
  }
}, []);
    const downloadCSV = () => {
        const headers = ["Sno", "Customer__Name", "Acc_no", "Code", "STB_no", "D_no", "Flat_name", "Street__name", "Phone", "Pay Status", "Plan Amount", "Paid Amount", "Paid_Date", "Balance Amount", "Discount Amount", "Advance Amount", "Pending Amount", "Staff__Code", "Network", "Paid_time", "Package", "Added_date", "Collection Staff"];
        const csvRows = [];
        csvRows.push(headers.join(","));
        customerData.forEach(row => { csvRows.push([row.id, row.name, row.account_num, row.acc_num, row.serial_num, row.doorno, row.flat_name, row.street, row.mobile, row.status, row.pay_amt, row.paid_amt, row.paid_date, row.balance, row.discount, row.extra_Balance_amt, row.pend_amt, row.area_code, row.net_name, row.paid_time, row.package, row.adate, row.col_boy].join(",")); });
        const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "CableTvPay.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    if (loading) return (
        <div className="content-wrapper d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" />
        </div>
    );

    if (error) return <div className='d-flex justify-content-center align-items-center min-vh-100'>Error: {error}</div>;

  return (
    <div className="content-wrapper min-vh-100 bg-light py-4 px-3">
      <ToastContainer theme="dark" />

      <div className="text-center mb-4">
        <h2 className="text-bold fw-bold">TCCL Upload</h2>
        <hr className="w-25 mx-auto" />
      </div>

      <div className="container bg-white shadow-sm rounded p-4">
        <div className="row justify-content-center">
          {/* Upload Section */}
          <div className="col-md-5 mb-4">
            <div className="form-group text-center">
              <label className="form-label fw-semibold text-dark">
                <FaUpload className="me-2 text-success" />
                Upload Format
              </label>
              <input
                type="file"
                accept=".csv"
                onChange={handleFileChange}
                className="form-control border bg-gradient-navy border-primary shadow-sm"
              />
            </div>
          </div>

          {/* Download Section */}
          <div className="col-md-5 mb-4">
            <div className="form-group text-center">
              <label className="form-label fw-semibold text-dark">
                <FaDownload className="me-2 text-primary" />
                Download Format
              </label>
              <br />
              <a
                href="tccl_upload.csv"
                download
                className="btn bg-gradient-navy shadow-sm mt-2 px-4"
              >
                <FaDownload className="me-2" />
                Download Template
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="text-left mb-lg-0 w-50">
                                    <h4 className="pb-0 mb-0 mt-1 text-navy">Filter Details</h4>
                                </div>
                            </div>
                            <div className="col-lg-8 mt-1">
                                <span>
                                    <div className="row w-auto">
                                        <div className="col-11 col-lg-6">
                                            <div className="input-group">
                                                <input type="text" className="form-control text-navy bg-light border-0 px-1 py-0" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{ borderRadius: "5px 0 0 5px" }} />
                                                <span className="input-group-text bg-light text-navy border-0 px-2" id="basic-addon1" style={{ borderRadius: "0 5px 5px 0" }} > <i className="fas fa-search" /> </span>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1 mt-lg-0">
                                            <div className="d-flex justify-content-end">
                                                <div className=" btn-group">
                                                    <button onClick={downloadCSV} className="btn btn-dark border-right px-lg-3 px-5 my-1 d-flex"><i className="fas fa-download pt-1 px-1" /> Download</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <table id="myTable" className="table table-striped bg-white table-bordered table-responsive">
                            <thead className="bg-gradient-navy">
                                <tr>
                                    <th>SI.NO</th>
                                    <th>STB NO</th>
                                    <th>Con Status</th>
                                    <th>Name</th>
                                    <th>ACC No</th>
                                    <th>Code</th>
                                    <th>D.NO</th>
                                    <th>Flat Name</th>
                                    <th>Street</th>
                                    <th>Mobile No</th>
                                    <th>Pay Status</th>
                                    <th>Plan Amount</th>
                                    <th>Paid Amount</th>
                                    <th>Paid Date</th>
                                 <th>Balance Amount</th>
                                 <th>Discount Amount</th>
                                 <th>Advance Amount</th>
                                 <th>Pending Amount</th>
                                 <th>Staff Code</th>
                                 <th>Network</th>
                                 <th>Paid Time</th>
                                 <th>Packages</th>
                                
                                 <th>Collection Staff</th>
                                 <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                               
                            {customerData.length > 0 ? (
                                    customerData.map((row, index) => (
                                        <tr key={index}>
                                           <td className='tableText'>{index + 1}</td>
                                            <td>{row.serial_num}</td>
                                            <td className='tableText'>
                                            {row.con_status === "active" || row.con_status === "Active" ? (
                                                <button className="btn btn-success">A</button>
                                            ) : row.con_status === "deactive" || row.con_status === "Deactive" ? (
                                                <div className="d-flex-column"><button className="btn btn-danger">D </button>{row.deactive_reason}</div>
                                            ) : (
                                                <div className="d-flex-column"><button className="btn btn-secondary">{row.con_status}</button>{row.deactive_reason}</div>
                                            )}
                                        </td>
                                            <td>{row.name}</td>
                                           <td>{row.account_num}</td>
                                           <td>{row.acc_num}</td>
                                           <td>{row.doorno}</td>
                                           <td>{row.flat_name}</td>
                                           <td>{row.street}</td>
                                           <td>{row.mobile}</td>
                                           <td>{row.status}</td>
                                           <td>{row.pay_amt}</td>
                                           <td>{row.paid_amt}</td>
                                           <td>{row.paid_date}</td>
                                           <td>{row.balance_amt}</td>
                                           <td>{row.discount}</td>
                                           <td>{row.extra_balance_amt}</td>
                                           <td>{row.pend_amt}</td>
                                           <td>{row.area_code}</td>
                                           <td>{row.network}</td>
                                           <td>{row.paid_time}</td>
                                           <td>{row.package}</td>
                                           <td>{row.col_boy}</td>
                                           <td className='tableText'>
                                           {row.con_status === "Unassigned" ? (
    <button className="btn btn-warning">Unassigned</button>
) : row.con_status?.toLowerCase() === "active" ? (
    <button className="btn btn-success">A</button>
) : row.con_status?.toLowerCase() === "deactive" ? (
    <div className="d-flex-column">
        <button className="btn btn-danger">D</button>
        {row.deactive_reason}
    </div>
) : (
    <button className="btn btn-secondary">{row.con_status}</button>
)}
                                        </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="30">No results found</td>
                                    </tr>
                                )}
                                  
                            </tbody>
                        </table>
                    </div>
                   
                </div>

    </div>
  );
}

export default TcclUpload;
